import { AnalyticsTab } from './AnalyticsTab.js';
import { RoutingTab } from './RoutingTab.js';
import {
  ActionButton,
  Actions,
  Container,
  List,
  Scroll,
} from './RoutingTabs.styles.js';

/**
 * In an ideal world this component would not exist and we would use
 * the `<Tabs />` component. But the styling currently is not 100% the same.
 *
 * Please double check you really want to use this.
 * @example
 * ```
 * <RoutingTabs>
 *   <RoutingTabs.List>
 *     <RoutingTabs.Tab to="/">To Home</RoutingTabs.Tab>
 *   </RoutingTabs.List>
 *
 *   <RoutingTabs.Actions>
 *     <Button>Some action</Button>
 *   </RoutingTabs.Actions>
 * </RoutingTabs>
 * ```
 */
export const RoutingTabs = Object.assign({}, Container, {
  ActionButton,
  Actions,
  Analytics: AnalyticsTab,
  List,
  Scroll,
  Tab: RoutingTab,
});
